export default __webpack_public_path__ + "static/media/releve-temp-materiel.ea20b09f.svg";